import { faApplePay } from "@fortawesome/free-brands-svg-icons/faApplePay";
import { faCcAmex } from "@fortawesome/free-brands-svg-icons/faCcAmex";
import { faCcMastercard } from "@fortawesome/free-brands-svg-icons/faCcMastercard";
import { faCcPaypal } from "@fortawesome/free-brands-svg-icons/faCcPaypal";
import { faCcVisa } from "@fortawesome/free-brands-svg-icons/faCcVisa";
import { faGooglePay } from "@fortawesome/free-brands-svg-icons/faGooglePay";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import ClearPay from "../assets/images/clearpay.svg?react";
import Klarna from "../assets/images/klarna.svg?react";
import Config from "../Config";

import "../assets/scss/components/_payment-types.scss";

export const PaymentTypes = () => {
	const { paymentMethodsEnabled } = Config;

	return (
		<div className="payment-card-types">
			<FontAwesomeIcon icon={faCcVisa} color="#2340E8" />
			<FontAwesomeIcon icon={faCcAmex} color="#1E74D0" />
			<div className="mastercard-wrapper">
				<FontAwesomeIcon icon={faCcMastercard} />
			</div>
			{paymentMethodsEnabled?.paypalEnabled && <FontAwesomeIcon icon={faCcPaypal} color="#0F388B" />}
			{paymentMethodsEnabled?.applePayEnabled && <FontAwesomeIcon icon={faApplePay} />}
			{paymentMethodsEnabled?.googlePayEnabled && <FontAwesomeIcon icon={faGooglePay} color="#41474A" />}
			{paymentMethodsEnabled?.clearpayEnabled && <ClearPay style={{ color: "#060606" }} />}
			{paymentMethodsEnabled?.klarnaEnabled && <Klarna />}
		</div>
	);
};

export default PaymentTypes;
